import moment from "moment";
import AirDatepicker from "air-datepicker";
import localeUk from 'air-datepicker/locale/uk';
import localeRu from 'air-datepicker/locale/ru';

export class StartContract {
    constructor({ insuranceForm, state }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;

        new AirDatepicker('input[name="start"]', {
            locale: this._lang === 'ru-ua' ? localeRu : localeUk,
            autoClose: true,
            dateFormat: 'yyyy-MM-dd',
            minDate: moment().format('yyyy-MM-DD'),
            selectedDates: [moment().format('yyyy-MM-DD')],
            onSelect: ({ date, formattedDate, datepicker }) => {
                this._state.start = moment(formattedDate);
            },
        });

        this._state.start = moment();
    }
}